/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { Link } from "react-router-dom";

import { portfolioItems } from "./portfolioData";
import Footer from "./Footer";
import Header from "./Header";

function PortfolioDetailsPage() {
  const { title } = useParams();
  // Decode the URL parameter to handle special characters and spaces
  const decodedTitle = decodeURIComponent(title);
  const portfolioItem = portfolioItems.find(
    (item) => item.title.toLowerCase() === decodedTitle.toLowerCase(),
  );

  if (portfolioItem) {
    return (
      <div>
        <Header className="header-inner-pages" />

        <main id="main">
          <section className="breadcrumbs">
            <div className="container">
              <div className="d-flex justify-content-between align-items-center">
                <h2>{portfolioItem.title}</h2>
                <ol>
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li>
                    <a href="/#portfolio">Portfolio</a>
                  </li>
                  <li>{portfolioItem.title}</li>
                </ol>
              </div>
            </div>
          </section>

          <section id="portfolio-details" className="portfolio-details">
            <div className="container">
              <div className="row gy-4">
                <div className="col-lg-8">
                  <div className="portfolio-details-slider swiper">
                    <div className="swiper-wrapper align-items-center">
                      {portfolioItem.images.map((image, index) => (
                        <div className="swiper-slide" key={index}>
                          <img src={image} alt="" />
                        </div>
                      ))}
                    </div>
                    <div className="swiper-pagination"></div>
                  </div>
                </div>

                <div className="col-lg-4">
                  <div className="portfolio-info">
                    <h3>Project information</h3>
                    <ul>
                      <li>
                        <strong>Category</strong>: {portfolioItem.category}
                      </li>
                      <li>
                        <strong>Project URL</strong>:{" "}
                        <a
                          href={portfolioItem.ProjectUrl}
                          target="_blank"
                          rel="noreferrer"
                          className="text-secondary"
                        >
                          Click here for more
                        </a>
                      </li>
                      <li>
                        <strong>Project Tools</strong>:{" "}
                        {portfolioItem.tools}{" "}
                      </li>
                      <li>
                        <strong>Role</strong>: {portfolioItem.Role}{" "}
                      </li>
                    </ul>
                  </div>
                  <div className="portfolio-description">
                    <h2>{portfolioItem.title}</h2>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: portfolioItem.description,
                      }}
                    ></p>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <Link
                      to="/portfolio-viewer"
                      className="btn btn-default btn-send"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View Full Portfolio
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer />

        <a
          href="#"
          className="back-to-top d-flex align-items-center justify-content-center"
        >
          <i className="bi bi-arrow-up-short"></i>
        </a>
      </div>
    );
  } else {
    return <Navigate to="/notfound" />;
  }
}

export default PortfolioDetailsPage;
